import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  selectedLanguage$ = new BehaviorSubject<string>(null);

  constructor() { }

  signOut(): void {
    window.sessionStorage.clear();
  }

  public selectLanguage(lang: string): void{
    this.saveLanguage(lang);
    this.selectedLanguage$.next(lang);
  }
  public saveLanguage(token: string): void {
    window.sessionStorage.removeItem('lang');
    window.sessionStorage.setItem('lang', token);
  }

  public getLanguage(): string{
    return this.selectedLanguage$.value ? this.selectedLanguage$.value : window.sessionStorage.getItem('lang');
  }
  public getLanguage$(): Observable<string>{
    if (this.selectedLanguage$.value === null){
      this.selectedLanguage$.next(this.getLanguage());
    }
    return this.selectedLanguage$.asObservable();
  }
  public getLang(): string {
    if (this.selectedLanguage$.value){
      return this.selectedLanguage$.value
    }else if (window.sessionStorage.getItem('language')){
      // @ts-ignore
      return window.sessionStorage.getItem('language')
    }else {
      return 'nl'
    }
  }
}
